module.exports = __webpack_public_path__ + "img/loading-icon.a0861442.svg";